// Shared field-level validators for the Profile forms (Personal Info +
// Passport tabs). Mirrors the rules/restrictions and error copy from the
// field-spec sheet.

// Letters, spaces, and "/" only (e.g. "Raja S/O Chandramohan"). No digits,
// no other special characters.
const PASSPORT_NAME_PATTERN = /^[A-Za-z\s/]+$/;

// Alphanumeric only, no special characters.
const PASSPORT_NUMBER_PATTERN = /^[A-Za-z0-9]+$/;

const DIGITS_ONLY_PATTERN = /^[0-9]+$/;

export const isValidPassportName = (value) =>
  PASSPORT_NAME_PATTERN.test(value.trim());

export const isValidPassportNumber = (value) =>
  PASSPORT_NUMBER_PATTERN.test(value.trim());

export const isValidMobileNumber = (value) =>
  DIGITS_ONLY_PATTERN.test(value.trim());

export const isValidPostcode = (value) =>
  value.trim() === "" || DIGITS_ONLY_PATTERN.test(value.trim());

export const isPastDate = (date) => Boolean(date) && date.getTime() < Date.now();

/** Passport expiry must not be more than 10 years after the date of issue. */
export const isExpiryWithinTenYears = (issueDate, expiryDate) => {
  if (!issueDate || !expiryDate) return true;
  const tenYearsAfterIssue = new Date(issueDate);
  tenYearsAfterIssue.setFullYear(tenYearsAfterIssue.getFullYear() + 10);
  return expiryDate.getTime() <= tenYearsAfterIssue.getTime();
};

export const GENDER_OPTIONS = ["Male", "Female", "Other"];

/** Golf handicap dropdown options, per spec: numbers 0-50. */
export const GOLF_HANDICAP_OPTIONS = Array.from({ length: 51 }, (_, i) => String(i));
